import { styled } from '@mui/material';

type BundleFooterBannerContainerProps = {
  isSticky: boolean;
};

export const BundleFooterBannerContainer = styled('div')<BundleFooterBannerContainerProps>(
  ({ theme, isSticky }) => `
  position: ${isSticky ? 'sticky' : 'relative'};
  bottom: 0;
  width: 100%;
  background-color: ${theme.palette.textOnPrimary.primary};
  color: ${theme.palette.textOnPrimary.primary};
  height: 160px;
  z-index: 1;

  ${theme.breakpoints.down('sm')} {
    height: 80px;
  }
`,
);
